import type { FromModel } from "@/__main__/data-model.mjs";
import createModel, {
  Mapped,
  Optional,
  Union,
} from "@/__main__/data-model.mjs";

export const postModel = {
  username: String,
  competitiveRank: Number,
  wingmanRank: Number,
  dangerZoneRank: Number,
  blitzAccountId: Optional(Union([String, Number])),
};

export const apiPostModelValidation = createModel(postModel);

export const model = {
  ...postModel,
  id: String,
  steamId: String,
  updatedAt: Date,
};

export const apiModelValidation = createModel(model);

export type CsgoPlayer = FromModel<typeof model>;

// @ts-ignore
const transform = (data) => {
  const profile = data?.data?.Player || data?.data?.CreatePlayer || data;
  return apiModelValidation(profile);
};

export const Players = createModel({ data: { players: [model] } }).transform(
  Mapped({ key: String, value: model }),
  (data) => {
    return data.data.players.reduce(
      (acc, p) => {
        acc[p.steamId] = p;
        return acc;
      },
      {} as Record<string, CsgoPlayer>,
    );
  },
);

export type CsgoPlayers = FromModel<typeof Players>;

export default transform;
